import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import LoanData from "../../../components/loanData";
import GuaranteeData from "../../../components/guaranteeData";
import NumberFormat from "react-number-format";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const ReturnMaturity = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Tablero de Control \ Regresar Vencimiento"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container spacing={2} justify="flex-end">
                            <Grid item>
                                <Button label="Regresar" onClick={props.handleReturnButton}
                                        className="p-button-secondary"/>
                            </Grid>
                            <Grid item>
                                <Button label="Guardar" onClick={props.returnLoanMaturity}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <LoanData
                        loanId={props.loanId}
                        selectedLoan={props.selectedLoan}
                        loading={props.loading}
                    />
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={6}>
                        <SubtitleLabel header="Días a Regresar" isBold={true}/>
                        <NumberFormat className={"p-inputtext p-component p-filled"}
                                      name="returnDays"
                                      thousandSeparator={true}
                                      decimalScale={0}
                                      allowNegative={false}
                                      maxLength={5}
                                      placeholder={"Ex: 99"}
                                      onChange={props.saveDataReturnMaturity}/>
                    </Grid> <Grid item xs={6}/>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <GuaranteeData
                        loanId={props.loanId}
                        loading={props.loading}
                        loanStatusPV={props.selectedLoan.statusPV}
                    />
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ReturnMaturity;